import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

/**
 * Componente raíz de la aplicación.
 *
 * Se limita a montar el `router-view` con una transición de desvanecido entre
 * vistas. El layout real (menú lateral y barra superior) vive en
 * `PaginaPrincipal`, que es la ruta padre de la que cuelgan casi todas las demás.
 *
 * La transición usa `mode="out-in"` para que la vista saliente termine de
 * desaparecer antes de que entre la nueva; sin eso, ambas coexisten un instante y
 * el layout salta.
 */

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view, null, {
    default: _withCtx(({ Component }) => [
      _createVNode(_Transition, {
        name: "fade",
        mode: "out-in"
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
        ]),
        _: 2
      }, 1024)
    ]),
    _: 1
  }))
}
}

})